export default __webpack_public_path__ + "static/media/certificate-ronnie-feng-young_jury.63ae6bbe.webp";